import styled from "styled-components";

export const ServiceCard = styled.a`
	align-items: center;
	border-radius: 8px;
	box-shadow: 0px 10px 25px -12px rgba(218, 218, 218, 0.25);
	color: #000;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	height: 223px;
	justify-content: space-between;
	width: 292px;
	&:hover {
		background-color: #1233db;
		color: #fff;
		transition: 0.3s ease-in-out;
	}

	.card-top {
		align-items: center;
		background-color: #f3f4fa;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		height: 100%;
		justify-content: center;
		width: 100%;
	}

	.card-bottom {
		align-items: center;
		display: flex;
		font-size: 20px;
		font-size: 20px;
		font-weight: 600;
		font-weight: 600;
		height: 60px;
		justify-content: center;
		width: 100%;
	}
`;
